<footer>
  <div class="footer-container">
    <!-- Top row: logo, links and donate button -->
    <div class="footer-top">
      <a
        *ngIf="footerLogo"
        class="logo-link"
        [href]="footerLogo.href"
        [target]="footerLogo.openNewTab ? '_blank' : '_self'"
        [attr.aria-label]="footerLogo.alt"
      >
        <img [src]="footerLogo.src" [alt]="footerLogo.alt" />
      </a>

      <nav class="footer-links" aria-label="Footer navigation">
        <ng-container *ngFor="let link of footerLinks">
          <!-- Internal links use routerLink -->
          <a
            *ngIf="isInternalLink(link)"
            [routerLink]="getLinkPath(link.href)"
            [fragment]="getLinkFragment(link.href)"
          >
            {{ link.labelKey | translate }}
          </a>
          <!-- External links use href -->
          <a
            *ngIf="!isInternalLink(link)"
            [href]="link.href"
            [target]="link.openNewTab ? '_blank' : '_self'"
          >
            {{ link.labelKey | translate }}
          </a>
        </ng-container>
      </nav>

      <rm-buttonlink
        *ngFor="let button of footerButtons"
        [id]="button.id + '-btn'"
        [design]="button.id === 'donate' ? 'primary' : 'normal'"
        [rounded]="true"
        [href]="button.href"
        [openNewTab]="button.openNewTab"
      >
        {{ button.labelKey | translate }}
      </rm-buttonlink>
    </div>

    <!-- Bottom row: all disclaimers in one place -->
    <div class="footer-bottom">
      <div class="disclaimers">
        <p class="disclaimer">
          {{ 'footer.user_content_disclaimer' | translate }}<br />{{
            'footer.pac_disclaimer' | translate
          }}
          {{ 'footer.copyright' | translate }}
        </p>
      </div>
    </div>
  </div>
</footer>
